import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const iconContainerVariants = cva(
  'flex items-center justify-center shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-slate-100 text-slate-600',
        primary: 'bg-blue-100 text-blue-600',
        secondary: 'bg-purple-100 text-purple-600',
        success: 'bg-emerald-100 text-emerald-600',
        warning: 'bg-amber-100 text-amber-600',
        destructive: 'bg-red-100 text-red-600',
        indigo: 'bg-indigo-100 text-indigo-600',
        cyan: 'bg-cyan-100 text-cyan-600',
        pink: 'bg-pink-100 text-pink-600',

        // Gradient backgrounds (for hero sections)
        'gradient-blue': 'bg-gradient-to-br from-blue-500 to-blue-600 text-white',
        'gradient-emerald': 'bg-gradient-to-br from-emerald-500 to-cyan-500 text-white',
      },
      size: {
        xs: 'w-6 h-6 rounded',
        sm: 'w-8 h-8 rounded-lg',
        md: 'w-10 h-10 rounded-lg',
        lg: 'w-12 h-12 rounded-xl',
        xl: 'w-16 h-16 rounded-full',
        '2xl': 'w-20 h-20 rounded-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export interface IconContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof iconContainerVariants> {}

const IconContainer = React.forwardRef<HTMLDivElement, IconContainerProps>(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(iconContainerVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </div>
    );
  }
);
IconContainer.displayName = 'IconContainer';

export { IconContainer, iconContainerVariants };
